// extracted by mini-css-extract-plugin
module.exports = {"author-name":"_3Q7Sw","author-name-large":"_2B-sd","author-name-base":"_16cut"};